<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Area</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="showAddForm = true; form = { village: '', subdistrict: '', district: '', province: '', postcode: '' }"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="viewData"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="filterActive"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item
                                @click="exportExcel({ endpoint: 'master/areas/report/exportexcel', name: 'areas', filter: filter })"
                            >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="areas"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
            <vs-prompt buttons-hidden title="Filter" :active.sync="showFilter">
                <div class="con-exemple-prompt">
                    <!-- <vs-input placeholder="Area ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
                    <vs-input label="Village" v-model="filter.village" class="mb-2 w-full" />
                    <vs-input label="Subdistrict" v-model="filter.subdistrict" class="mb-2 w-full" />
                    <vs-input label="District" v-model="filter.district" class="mb-2 w-full" />
                    <vs-input label="Province" v-model="filter.province" class="mb-2 w-full" />
                    <vs-input label="Postcode" v-model="filter.postcode" class="mb-2 w-full" />
                    <vs-row
                        vs-align="flex-start"
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-w="12"
                        class="mt-5"
                    >
                        <vs-button color="primary" @click="filterData">Search</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <!-- Form add data -->
            <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
                <div class="con-exemple-prompt">
                    <!-- <vs-input placeholder="Area ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
                    <vs-input label="Village *" v-model="form.village" class="mb-2 w-full" />
                    <vs-input label="Subdistrict *" v-model="form.subdistrict" class="mb-2 w-full" />
                    <vs-input label="District *" v-model="form.district" class="mb-2 w-full" />
                    <vs-input label="Province *" v-model="form.province" class="mb-2 w-full" />
                    <vs-input label="Postcode *" v-model="form.postcode" class="mb-2 w-full" />
                    <vs-row
                        vs-align="flex-start"
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-w="12"
                        class="mt-5"
                    >
                        <vs-button color="primary" @click="addData">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <!-- Form view data -->
            <vs-prompt buttons-hidden title="Add" :active.sync="showViewForm">
                <div class="con-exemple-prompt">
                    <!-- <vs-input placeholder="Area ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
                    <vs-input
                        label="Village *"
                        v-model="form.village"
                        class="mb-2 w-full"
                        :disabled="!editMode"
                    />
                    <vs-input
                        label="Subdistrict *"
                        v-model="form.subdistrict"
                        class="mb-2 w-full"
                        :disabled="!editMode"
                    />
                    <vs-input
                        label="District *"
                        v-model="form.district"
                        class="mb-2 w-full"
                        :disabled="!editMode"
                    />
                    <vs-input
                        label="Province *"
                        v-model="form.province"
                        class="mb-2 w-full"
                        :disabled="!editMode"
                    />
                    <vs-input
                        label="Postcode *"
                        v-model="form.postcode"
                        class="mb-2 w-full"
                        :disabled="!editMode"
                    />
                    <vs-row
                        vs-align="flex-start"
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-w="12"
                        class="mt-5"
                    >
                        <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
                        <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            showFilter: false,
            showAddForm: false,
            showViewForm: false,
            filter: {
                village: "",
                subdistrict: "",
                district: "",
                province: "",
                postcode: ""
            },
            form: {
                village: "",
                subdistrict: "",
                district: "",
                province: "",
                postcode: ""
            },
            editMode: false,
            areas: [],
            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },

        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this area?",
                accept: this.acceptAlert
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("master/areas/" + this.selectedId + "/destroy")
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Area deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected area was successfully deleted"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => {
                    this.fetchData();
                });
        },
        refreshData() {
            this.fetchData();
        },
        addData() {
            this.isLoading = true;
            this.$http
                .post("master/areas/store", this.form)
                .then(res => {
                    this.showAddForm = false;
                    this.fetchData();
                    const message = res.data.message
                        ? res.data.message
                        : "Success.";
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/areas/" + this.selectedId)
                .then(res => {
                    this.editMode = false;
                    this.form = res.data;
                    this.showViewForm = true;
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        saveData() {
            this.isLoading = true;
            this.$http
                .put("master/areas/" + this.selectedId + "/update", this.form)
                .then(res => {
                    this.editMode = false;
                    this.showViewForm = false;
                    this.selectedId = null;
                    this.fetchData();
                    const message = res.data.message
                        ? res.data.message
                        : "Success.";
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post("master/areas?page=" + this.currentPage, this.filter)
                .then(resp => {
                    this.areas = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    this.isLoading = false;
                })
                .catch(resp => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                });
        },
        filterData() {
            this.currentPage = 1;
            this.showFilter = false;
            this.fetchData();
        },
        filterActive() {
            this.showFilter = !this.showFilter;
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/areas/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "area-upload-template.xlsx");
                });
        },
        uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/areas/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Areas Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            // {
            //   headerName: "ID",
            //   field: "id",
            //   filter: true,
            //   width: 50
            // },
            {
                headerName: "Village",
                field: "village",
                width: 250
            },
            {
                headerName: "Subdistrict",
                field: "subdistrict",
                width: 200
            },
            {
                headerName: "District",
                field: "district",
                width: 200
            },
            {
                headerName: "Province",
                field: "province",
                width: 300
            },
            {
                headerName: "Postcode",
                field: "postcode",
                width: 150
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>